import { request } from '@/utils/request'

export function classMap (params) {
  return request({
    url: '/api/map/class',
    method: 'get',
    params
  })
}

export function experimentList (params) {
  return request({
    url: '/api/admin/portal/experiment/list',
    method: 'get',
    params
  })
}

export function experimentDetail (params) {
  return request({
    url: '/api/experiment/examine/detail',
    method: 'get',
    params
  })
}

export function stuExperimentDetail (params) {
  return request({
    url: '/api/student/examine/report',
    method: 'get',
    params
  })
}

export function experimentSave (data) {
  return request({
    url: '/api/experiment/examine/save',
    method: 'post',
    data
  })
}

export function collegeList (params) {
  return request({
    url: '/api/admin/school/org/list',
    method: 'get',
    params
  })
}

export function majorList (params) {
  return request({
    url: '/api/admin/school/major/list',
    method: 'get',
    params
  })
}

export function examineDetails (params) {
  return request({
    url: '/api/examine/study/detail',
    method: 'get',
    params
  })
}

export function stepDetails (params) {
  return request({
    url: '/api/examine/study/step/detail',
    method: 'get',
    params
  })
}

export function uncommittedExport (params) {
  return request({
    url: '/api/examine/not_submitted/export',
    method: 'get',
    responseType: 'blob',
    params
  })
}

export function stepExport (params) {
  return request({
    url: '/api/examine/operate_detail/export',
    method: 'get',
    responseType: 'blob',
    params
  })
}

export function exerciseDetails (params) {
  return request({
    url: '/api/experiment/practice/detail',
    method: 'get',
    params
  })
}

export function stuExerciseDetails (params) {
  return request({
    url: '/api/student/experiment/practice/detail',
    method: 'get',
    params
  })
}

export function ticket (params) {
  return request({
    url: '/api/portal/experiment/ticket',
    method: 'get',
    params
  })
}

export function portalExperimentDetail (params) {
  return request({
    url: '/api/portal/experiment/detail',
    method: 'get',
    params
  })
}

// 上传实验报告
export function uploadExperimentReport (data) {
  return request({
    url: '/api/student/experiment-report/upload',
    method: 'post',
    data
  })
}

// 实验考核-批改-学生报告列表
export function studentReportList (params) {
  return request({
    url: '/api/examine/report/list',
    method: 'get',
    params
  })
}

// 实验考核-批改-批改报告
export function correctReport (data) {
  return request({
    url: '/api/examine/report/check',
    method: 'post',
    data
  })
}
